import productJson from "./product.json";
import { Button, Image } from "antd";
import { iconsAndImages } from "../../assets/images";
import { useEffect, useState } from "react";
import "./style.scss";
import { MdZoomIn } from "react-icons/md";
import { BsBoxArrowInUpRight } from "react-icons/bs";

export const Products = () => {
    const [activeFilter, setActiveFilter] = useState("all");
    const [filteredProduct, setFilteredProduct] = useState([]);
    const [visibleCount, setVisibleCount] = useState(10);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");

    const buttonOptions = [
        { name: "All", key: "all" },
        { name: "Korai", key: "korai" },
        { name: "Box", key: "box" },
        { name: "Oil", key: "oil" },
        { name: "Electrical & Electronic's", key: "electrical" },
        { name: "Kitchen&Home Applience", key: "kitchen" },
        { name: "Construction Material & Tools", key: "construction" },
    ];

    const handleChangeFilter = (key) => {
        setActiveFilter(key);
        setVisibleCount(10);
    };

    useEffect(() => {
        const productList =
            activeFilter === "all"
                ? productJson?.listOfCatalog
                : productJson?.listOfCatalog?.filter(
                    (details) => details?.category === activeFilter
                );
        setFilteredProduct(productList);
    }, [activeFilter]);

    const handleLoadMore = () => {
        setVisibleCount((prev) => prev + 10);
    };

    return (
        <section className="py-5">
            <div className="container">
                <span className="text-yellow fw-bold d-block mb-2">
                    {productJson?.info}
                </span>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-2">
                    <h1 className="bebas-neue-regular mb-0">{productJson?.title}</h1>
                </div>
                <div className="filter-scroll d-flex gap-2 mb-4">
                    {buttonOptions?.map((details) => (
                        <Button
                            key={details.key}
                            type={details.key === activeFilter ? "primary" : "default"}
                            onClick={() => handleChangeFilter(details.key)}
                        >
                            {details.name}
                        </Button>
                    ))}
                </div>

                <div className="row g-4">
                    <div className="catalog-masonry">
                        {filteredProduct?.slice(0, visibleCount)?.map((details, index) => (
                            <div
                                className="catalog-item"
                                key={index}
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                            >
                                <div className="catalog-card">
                                    <div className="catalog-img-wrap">
                                        <img
                                            src={iconsAndImages[details?.catalogImg]}
                                            alt={details?.name}
                                            className="catalog-img"
                                            loading="lazy"
                                        />
                                        <div className="catalog-overlay">
                                            <h6 className="catalog-title">{details?.name}</h6>
                                            <div className="zoom-icon d-flex gap-4">
                                                <MdZoomIn style={{ fontSize: "25px" }} title="Preview"
                                                    onClick={() => {
                                                        setPreviewImage(iconsAndImages[details?.catalogImg]);
                                                        setPreviewOpen(true);
                                                    }}
                                                />
                                                <BsBoxArrowInUpRight title="Order Now" style={{ fontSize: "25px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <Image
                    src={previewImage}
                    style={{ display: "none" }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                    }}
                />

                <div className="d-flex justify-content-center mt-4">
                    {visibleCount < filteredProduct.length && (
                        <Button type="primary" onClick={handleLoadMore}>
                            Load More
                        </Button>
                    )}
                </div>
            </div>
        </section>
    );
};